import React, {useEffect, useState} from 'react';
import {Card, CardBody, CardTitle,} from 'reactstrap';

import {
    ARE_YOU_SHURE_MSG,
    ARE_YOU_SHURE_TITLE,
    LIST,
    NO, NO_DATA_FOUND,
    YES
} from "../../../components/i18n/i18n";
import {confirmAlert} from 'react-confirm-alert';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import {ButtonTableDelete, ButtonTableEdit} from "../../../components/buttons/buttonsActions";
import { setViewMode } from "../../../redux/actions/generalActions/mainActions";
import {setForm, setItem} from "../../../redux/actions/generalActions/formActions";
import {connect} from "react-redux";
import {setFilter, setTableParams} from "../../../redux/actions/generalActions/listActions";
import {remove, search} from "../../../redux/actions/eventx/mapConfigActions";
import {ModalFormContainer} from "../../../components/confirmAlert/ModalFormContainer";
import MapConfigForm from "./_form";

function MapConfigList(props) {
    const { pageSize, pageIndex, totalSize, listDomainObjects, filter } = props.listProps
    const { udn } = props.mainProps;
    const [staticFilter, setStaticFilter] = useState({
        fbDataBase : {  id : null },
        item : {
            udn: udn?.id
        }
    })

    useEffect(()=>{
        setStaticFilter({
            ...staticFilter,
            fbDataBase: { id : props.mainProps?.app?.fbDataBase?.id },
            item :{
                udn: udn?.id
            }
        })

    },[props.mainProps?.app?.fbDataBase?.id, udn?.id])

    useEffect(() => {
        if(!staticFilter.fbDataBase.id || !staticFilter.item.udn)
            return;
        if ( filter === undefined || filter === null){
            refreshDataList(pageIndex, pageSize, staticFilter);
            return;
        }
        refreshDataList(pageIndex, pageSize, filter);
    }, [pageIndex, pageSize, filter, staticFilter]);

    const refreshDataList =  (_pageIndex, _pageSize, _filter) => props.search(_pageIndex, _pageSize, _filter)

    const handleTableChange = (type, tableChangeParams) => {
        let currentIndex = (tableChangeParams.page - 1) * tableChangeParams.sizePerPage;
        props.setTableParams( tableChangeParams.sizePerPage, currentIndex );
    };

    const confirmDelete = (data) => {
        return confirmAlert({
            closeOnEscape: true,
            closeOnClickOutside: true,
            customUI: ({onClose}) => {
                return (
                    <div className='custom-ui'>
                        <h1>{ARE_YOU_SHURE_TITLE}</h1>
                        <p>{ARE_YOU_SHURE_MSG}</p>
                        <button onClick={onClose}>{NO}</button>
                        <button className={"btn-alert-delete"} onClick={() => {
                            deleteItem(data)
                            onClose();
                        }}>
                            {YES}
                        </button>
                    </div>
                );
            }
        });
    };

    const deleteItem = (data) => {
        const fbDataBase = staticFilter.fbDataBase
        props.remove(data.id, fbDataBase)
    }

    const editItem = (data) => {
        props.setForm(true, false, false);
        props.setItem(data);
        ModalFormContainer(MapConfigForm, { data: data, Form: MapConfigForm });
    }

    const actionsFormatter = (cell, row) => <>
        <ButtonTableEdit onClick={() => editItem(row)}/>
        <ButtonTableDelete onClick={() => confirmDelete(row)}/>
    </>

    const columns = [{
        dataField: 'id',
        text: 'ID',
        hidden: true
    }, {
        dataField: 'uid',
        text: 'UID',
        headerAlign: 'center',
        align: 'center',
        headerStyle: {width: '200px'},
    }, {
        dataField: 'platform',
        text: 'Plataforma',
        headerAlign: 'center',
        align: 'center',
    }, {
        dataField: 'defaultZoom',
        text: 'Zoom Inicial',
        headerAlign: 'center',
        align: 'center',
    }, {
        dataField: 'minZoom',
        text: 'Zoom Mínimo',
        headerAlign: 'center',
        align: 'center',
    }, {
        dataField: 'maxZoom',
        text: 'Zoom Máximo',
        headerAlign: 'center',
        align: 'center',
    }, {
        dataField: 'imgOverlay',
        text: 'Overlay',
        headerAlign: 'center',
        align: 'center',
    }, {
        isDummyField: true,
        text: 'Acción',
        headerStyle: {width: '130px'},
        headerAlign: 'center',
        align: 'center',
        formatter: actionsFormatter
    }];

    return (
        <div>
            <Card>
                <CardTitle className="bg-light border-bottom p-3 mb-0">
                    <i className="far fa-list-alt mr-2"> </i>{LIST}
                </CardTitle>
                <CardBody className="">
                    <BootstrapTable
                        striped hover
                        tableHeaderClass='mb-0'
                        remote
                        keyField="id"
                        data={listDomainObjects || []}
                        columns={columns}
                        noDataIndication={NO_DATA_FOUND}
                        pagination={paginationFactory({pageIndex, pageSize, totalSize})}
                        onTableChange={handleTableChange}
                    />
                </CardBody>
            </Card>
        </div>
    )
}

const mapStateToProps = state => ({
    mainProps : state.mainProps,
    listProps : state.listProps,
})

const mapActionsToProps = ({
    setFilter,
    setTableParams,
    setViewMode,
    setForm,
    setItem,
    search,
    remove,
})
export default connect(mapStateToProps, mapActionsToProps)(MapConfigList)